/* unplugin-vue-components disabled */import { render } from "./average-chart.vue?vue&type=template&id=16e0f3cc&scoped=true"
import script from "./average-chart.vue?vue&type=script&lang=js"
export * from "./average-chart.vue?vue&type=script&lang=js"

import "./average-chart.vue?vue&type=style&index=0&id=16e0f3cc&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/amoeba-logistics-information-system-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e0f3cc"]])

export default __exports__